<script setup lang="ts">
import { defineProps } from 'vue';
import { twMerge } from "tailwind-merge";
import { type BadgeVariants, badgeVariants } from './variants'

const props = defineProps<{
  variant?: BadgeVariants['variant']
  size?: BadgeVariants['size']
}>()
</script>

<template>
  <span :class="twMerge(badgeVariants({variant: props.variant, size: props.size}), $attrs.class)">
    <slot />
  </span>
</template>

<style scoped>

</style>
